// QR Code Designer API (designs stored in the existing graphicpromos
// collection, owner-only routes /graphic-promo/qr-designs).
import { elakay_API } from "../../config";
import { isAuthenticated } from "../auth";
import { uploadFileRequest } from "../../utils/uploadRequest";

const authHeaders = () => {
  const token = isAuthenticated()?.token || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handle = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    const error = new Error(data.error || `Erreur ${response.status}`);
    error.status = response.status;
    error.code = data.code;
    throw error;
  }
  return data;
};

const multipart = (design, previewBlob) => {
  const form = new FormData();
  form.append("data", JSON.stringify(design));
  if (previewBlob) form.append("previewImage", previewBlob, "qr-preview.png");
  return form;
};

export const qrDesignImageUrl = (design) =>
  design?._id ? `${elakay_API}/graphic-promo/${design._id}/image?v=${encodeURIComponent(design.updatedAt || "")}` : "";

export const listQrDesigns = () =>
  fetch(`${elakay_API}/graphic-promo/qr-designs`, { headers: { Accept: "application/json", ...authHeaders() } }).then(handle);

export const createQrDesign = (design, previewBlob) =>
  fetch(`${elakay_API}/graphic-promo/qr-designs`, { method: "POST", headers: authHeaders(), body: multipart(design, previewBlob) }).then(handle);

export const updateQrDesign = (id, design, previewBlob) =>
  fetch(`${elakay_API}/graphic-promo/qr-designs/${id}`, { method: "PUT", headers: authHeaders(), body: multipart(design, previewBlob) }).then(handle);

export const activateQrDesign = (id) =>
  fetch(`${elakay_API}/graphic-promo/qr-designs/${id}/activate`, { method: "PUT", headers: { Accept: "application/json", ...authHeaders() } }).then(handle);

export const duplicateQrDesign = (id) =>
  fetch(`${elakay_API}/graphic-promo/qr-designs/${id}/duplicate`, { method: "POST", headers: { Accept: "application/json", ...authHeaders() } }).then(handle);

export const deleteQrDesign = (id) =>
  fetch(`${elakay_API}/graphic-promo/qr-designs/${id}`, { method: "DELETE", headers: { Accept: "application/json", ...authHeaders() } }).then(handle);

// Image files for "Save to Media Library": the existing PageBuilder media
// upload (role-checked server side) + the shared media library entry.
export const uploadMediaFile = async (file) => {
  const data = await uploadFileRequest({ url: `${elakay_API}/media/upload`, feature: "media", file, headers: authHeaders(), throwOnError: true });
  if (!data.url) throw Object.assign(new Error("Réponse d'envoi incomplète."), { status: 502 });
  return data;
};
